import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { costs } from '../data/problems';
export function ProblemSection() {
  return <section className="bg-orange-50 py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-194" data-mp="30gxtpw8ufdm8">
      <div className="mx-auto max-w-4xl px-4" data-id="element-195" data-mp="30j0qr08ey70g">
        <div className="text-center" data-id="element-196" data-mp="2vpg2w10jatez">
          <h2 id="problem-title" className="text-balance text-3xl font-extrabold leading-tight text-green-950 sm:text-4xl" data-id="element-197" data-mp="2voehp3pt0qjj">
            Does this sound familiar?
          </h2>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-stone-900" data-id="element-198" data-mp="35fr7lps1l6mx">
            Sunday at 11 p.m. Tomorrow you have Oil &amp; Gas class. And you're still searching for the best way to
            explain upstream, midstream, and downstream operations, how drilling works, and the role of Oil &amp; Gas in
            modern energy systems without losing your students' attention.
          </p>
          <p className="mx-auto mt-4 max-w-3xl leading-relaxed text-stone-600" data-id="element-199" data-mp="1k52ak3szwhgo">
            It's not your fault. You've spent years struggling with disorganized materials, dense theory from outdated
            textbooks, and resources designed for contexts you have to completely rewrite.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 rounded-xl border border-stone-200 bg-white p-6 shadow-sm sm:p-8" data-id="element-200" data-mp="sbyw46qg9xxw">
          <p className="mb-5 inline-flex items-center gap-2 text-xl font-bold text-green-950" data-id="element-201" data-mp="1c228fsvfxs0f">
            <AlertTriangleIcon className="h-5 w-5 text-red-700" aria-hidden="true" data-id="element-202" data-mp="1g348ud13ga3z" />
            The real cost of not having the right materials
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-203" data-mp="3duyra1vldyv3">
            {costs.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-stone-600" data-id="element-204" data-mp="3hv98kaou4bp9">
                <span className="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full bg-red-700" aria-hidden="true" data-id="element-205" data-mp="p120m7zeoxn6" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="mt-10 text-center" data-id="element-206" data-mp="y1qen2osuy02">
          <p className="text-lg font-bold text-green-950" data-id="element-207" data-mp="xym4zpskfa20">
            Stop giving away your personal time. Your dedication is already there. What you need now is the right tool.
          </p>
          <p className="mt-3 text-2xl font-extrabold text-stone-700 sm:text-3xl" data-id="element-208" data-mp="17ws1tszilq00">
            Plan your entire year today.
          </p>
        </div>
      </div>
    </section>;
}